import { toISOString } from '@/utils/date';

function transformItem2Dto(item) {
  const dto = {
    vatTypeRateID: item.id,
    ...item,
    startDate: toISOString(item.startDate)
  };
  delete dto.id;
  return dto;
}

export const apiOverrides = { transformItem2Dto };
